import { render, staticRenderFns } from "./DetailPurchasedCredit.vue?vue&type=template&id=a2ef54a0&scoped=true&"
import script from "./DetailPurchasedCredit.vue?vue&type=script&lang=js&"
export * from "./DetailPurchasedCredit.vue?vue&type=script&lang=js&"
import style0 from "./DetailPurchasedCredit.vue?vue&type=style&index=0&id=a2ef54a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ef54a0",
  null
  
)

export default component.exports